import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const uploadSpeakerImageApi = createAsyncThunk(
  "auth/image/speaker/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.globalsAction(`upload/assets`, 0), data, { headers: { "Content-Type": "multipart/form-data" } })

      return response?.data;
    } catch (error) {
      //console.log("error",error);
      // return rejectWithValue(error?.response?.data);
       return rejectWithValue({
        status: error?.response?.status,
        data: error?.response?.data,
        statusText: error?.response?.statusText,
      });
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }
const uploadSpeakerImageSlice = createSlice({
  name: "speaker_image_upload",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetImage: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadSpeakerImageApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(uploadSpeakerImageApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(uploadSpeakerImageApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetImage } = uploadSpeakerImageSlice.actions;
export const uploadSpeakerImageReducer = uploadSpeakerImageSlice.reducer;
